module.exports = __webpack_public_path__ + "static/logo-select-8d0e3f6680a04b01756a649e5bad3911.png";